import { dataArrowToBottom } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowToBottom = /*#__PURE__*/createIcon(dataArrowToBottom)
export default IconArrowToBottom
